
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOnboardingContext } from '@/context/OnboardingContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoading, onboardingComplete } = useOnboardingContext();

  console.log('ProtectedRoute - isLoading:', isLoading, 'onboardingComplete:', onboardingComplete);

  // Show loading while checking authentication status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // Redirect to onboarding if not completed
  if (!onboardingComplete) {
    console.log('ProtectedRoute - User not authenticated, redirecting to /onboarding');
    return <Navigate to="/onboarding" replace />;
  }

  // Render protected content if authenticated
  console.log('ProtectedRoute - User authenticated, rendering children');
  return <>{children}</>;
};

export default ProtectedRoute;
